import { useFindAllRecentAgenciesGroupedByNetwork } from '@/hooks/useDistributors';
import StyledTable from '../styled/StyledTable';
import { NETWORK_COLUMNS } from '@/types/distributors/networkColumnDef';
import AgenciesSubList from './AgenciesSubList';
import { RowSelectionState } from '@tanstack/react-table';
import { useTranslation } from '@/i18n';
import { useTranslatedConst } from '@/hooks/useTranslatedConst';

interface RecentAgenciesGroupedByNetworksProps {
  filters: {
    networkId?: string;
    networkName?: string;
  };
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>;
  setSelectedAgencies: React.Dispatch<
    React.SetStateAction<Record<string, string[]>>
  >;
  selectedNetworks: string[];
}

const RecentAgenciesGroupedByNetworks = ({
  filters,
  setRowSelection,
  setSelectedAgencies,
  selectedNetworks,
}: RecentAgenciesGroupedByNetworksProps) => {
  const { t } = useTranslation();
  const getTranslatedConst = useTranslatedConst();
  const { data: networksWithAgencies, isSuccess } =
    useFindAllRecentAgenciesGroupedByNetwork({
      networkId: filters.networkId || undefined,
      networkName: filters.networkName || undefined,
    });

  return (
    <>
      <StyledTable
        columns={getTranslatedConst(NETWORK_COLUMNS)}
        data={networksWithAgencies ?? []}
        getRowId={(row) => row.id}
        isExpandable
        getRowCanExpand={(row) => row.original._count.Agency > 0}
        expandedNode={(row) => (
          <AgenciesSubList
            networkId={row.original.id}
            setSelectedAgencies={setSelectedAgencies}
            key={`agencies-list-${row.original.id}`}
            shouldSelectAll={selectedNetworks.includes(row.original.id)}
            recentOnly
          />
        )}
        onRowClick={(row) => {
          row.toggleExpanded();
        }}
        setSelection={setRowSelection}
      />
      <div className="flex flex-row justify-between items-center gap-3 pl-6">
        <span className="text-sm leading-6 text-gray-700 font-medium">
          {isSuccess && networksWithAgencies.length > 0
            ? networksWithAgencies.length === 1
              ? t('distributors.counts.oneNetwork')
              : t('distributors.counts.multipleNetworks', {
                  count: networksWithAgencies.length,
                })
            : t('distributors.noDistributorNetworksFound')}
        </span>
      </div>
    </>
  );
};

export default RecentAgenciesGroupedByNetworks;
